export const rules = {
  goodsName: [
    { required: true, message: '请输入产品名称', trigger: 'blur' }
  ],
  vendorId: [
    { required: true, message: '请选择所属企业', trigger: 'change' }
  ],
  sortNumber: [
    { required: true, message: '请输入排序值', trigger: 'blur' }
  ],
  goodsSmallImage: [
    { required: true, message: '请上传产品首图', trigger: 'change' }
  ],
  brandName: [
    { required: false, message: '请输入品牌', trigger: 'blur' }
  ],
  originregion: [
    { required: true, message: '请输入产品产地', trigger: 'blur' }
  ],
  netContent: [
    { required: true, message: '请输入净含量', trigger: 'blur' }
  ],
  shelflife: [
    { required: true, message: '请输入保质期', trigger: 'blur' }
  ],
  attributes: [
    { required: false, type: 'array', message: '请输入自定义属性', trigger: 'change' }
  ],
  goodsDetailsImage: [
    { required: true, message: '请上传产品介绍图片', trigger: 'change' }
  ],
  certIds: [
    { required: false, message: '请选择产品质量证书', trigger: 'change' }
  ],
  status: [
    { required: true, message: '请选择是否上架', trigger: 'change' }
  ]
}

export const statusList = [
  { label: '全部状态', value: null },
  { label: '已上架', value: 1 },
  { label: '已下架', value: 2 }
]
